/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function StackCompactIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "stack-compact", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M19.5 9.5H5.5V6.5H19.5V9.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M19.5 12.5H5.5V9.5H19.5V12.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M19.5 15.5H5.5V12.5H19.5V15.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M19.5 18.5H5.5V15.5H19.5V18.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(StackCompactIcon);
export default ForwardRef;
//# sourceMappingURL=stackCompactIcon.js.map